import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: '¿Sirve si soy principiante o si ya corro hace años?',
  a: 'Es más eficaz cuanto antes lo incorporás, pero funciona en cualquier nivel. Si sos principiante, el Pack te va a dar la base mental que el 90% de los corredores nunca construye. Si sos avanzado, vas a entender por qué hay un techo que no podés romper y cómo derribarlo.'
}, {
  q: '¿Tengo que estar entrenando para una carrera específica para aprovecharlo?',
  a: 'No. El sistema está diseñado para aplicarse en cualquier momento del ciclo de entrenamiento. Es igual de poderoso en pretemporada, en peak training o en el día previo a una competencia.'
}, {
  q: '¿Esto reemplaza a un entrenador o psicólogo deportivo?',
  a: 'No reemplaza, complementa. Pero te da acceso inmediato a herramientas de psicología deportiva de élite que normalmente solo están disponibles para atletas profesionales. Por menos de lo que cuesta una sola sesión, tenés un sistema completo para toda la vida.'
}, {
  q: '¿En cuánto tiempo veo resultados?',
  a: 'Los primeros cambios los notás en los primeros entrenamientos. El Tomo 1 te cambia la perspectiva sobre el cansancio desde la primera lectura. Los resultados en marcas y consistencia se consolidan entre 3 y 6 semanas de aplicación.'
}, {
  q: '¿Cómo recibo el producto?',
  a: 'Inmediatamente después del pago recibís un email con el enlace de descarga. Todo en formato PDF optimizado para leer en celular, tablet o computadora. Sin esperas, sin envíos físicos, sin complicaciones.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Preguntas frecuentes" className="bg-ink" data-id="element-55" data-mp="wz78uy29sx88">
      <div className="mx-auto max-w-3xl px-5 py-12" data-id="element-56" data-mp="iymss9nqpfif">
        <h2 className="text-center font-display text-3xl font-bold text-white sm:text-4xl" data-id="element-57" data-mp="iywg1pheh8kf">
          ❓ Lo que más nos preguntan
        </h2>
        <div className="mt-10 divide-y divide-white/10 overflow-hidden rounded-2xl border border-azul/15 bg-ink-2" data-id="element-58" data-mp="2pmdci2c23cra">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-59" data-mp="2fwam89wbkcwn" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-white/[0.03] focus:outline-none focus-visible:bg-white/[0.05]" data-id="element-60" data-mp="2fxllpxiqeyhy">
                  <span className="text-sm font-bold text-white sm:text-base" data-id="element-61" data-mp="2yma7smsyb9vb">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-naranja-soft" data-id="element-62" data-mp="2ul6otrflwxpv" /> : <PlusIcon className="h-5 w-5 shrink-0 text-azul-soft" data-id="element-63" data-mp="1n9hgfd42onfs" />}
                </button>
                <div className="grid transition-[grid-template-rows] duration-300 ease-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-64" data-mp="1j8xlmg6z1vwt">
                  <div className="overflow-hidden" data-id="element-65" data-mp="2nrh0ed63ib3">
                    <p className="px-6 pb-5 text-sm leading-relaxed text-white/65" data-id="element-66" data-mp="7o5pfxioku9n">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}